import { render, staticRenderFns } from "./applyStudentOnlineForm.vue?vue&type=template&id=070409c8"
import script from "./applyStudentOnlineForm.vue?vue&type=script&lang=js"
export * from "./applyStudentOnlineForm.vue?vue&type=script&lang=js"
import style0 from "./applyStudentOnlineForm.vue?vue&type=style&index=0&id=070409c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports